import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import Constants from 'expo-constants'
import * as Permissions from 'expo-permissions'
import * as ImagePicker from 'expo-image-picker'
import { useNavigation } from '@react-navigation/native'
import { View, TouchableOpacity, SafeAreaView, ViewPropTypes } from 'react-native'
import Image from '../../../../components/Image'
import { updatePhotoUserInformation } from '../../../../redux/profile/userInformationActions'
import { Icon, Spinner } from '../../../../components'
import { useTheme } from '../../../../theming/ThemeProvider'
import { getAvatarImage } from '../../../../tools/dataParse'
import notificationActions from '../../../../redux/notifications/notificationActions'
import styles from './styles'
import { userInformationSelector } from '../../../../redux/profile/userInformationSelector'
import ParticlesBackground from '../../../../components/ParticlesBackground'

const ProfileTopbar = ({ style, handleHelpModal }) => {
  const navigation = useNavigation()
  const dispatch = useDispatch()
  const { theme, setTheme } = useTheme()
  const { user, updateUserPhotoLoading } = useSelector(userInformationSelector)
  const { theme: themeName } = useSelector(state => state.globalThemeReducer)
  const [isLightTheme, setIsLightTheme] = useState(themeName === 'LIGHT_THEME')
  useEffect(() => {
    getPermissionAsync()
  }, [])

  const getPermissionAsync = async () => {
    if (Constants.platform.ios && Constants.platform.android) {
      const { status } = await Permissions.askAsync(Permissions.CAMERA_ROLL)
      if (status !== 'granted') {
        alert('Sorry, we need camera roll permissions to make this work!')
      }
    }
  }

  const onGoBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.navigate('main')
    }
  }

  const handleImagePicker = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        quality: 0.5
      })
      if (!result.cancelled) {
        const payload = new FormData()
        const uri = result.uri
        const name = uri.split('/').pop()
        const match = /\.(\w+)$/.exec(name)
        const type = match ? `image/${match[1]}` : 'image'

        payload.append('avatar', { uri, name, type })
        dispatch(updatePhotoUserInformation(payload))
      }
    } catch (E) {
      dispatch(notificationActions.SendToast(({ message: E, type: 'error' })))
    }
  }

  const handleSetToggle = () => {
    setTheme(isLightTheme ? 'DARK_THEME' : 'LIGHT_THEME')
    setIsLightTheme(!isLightTheme)
  }

  return (
    <View style={[style, styles.header]}>
      <View style={styles.imageBackground}>
        <ParticlesBackground>
          <SafeAreaView />
          <View style={styles.topOptions}>
            <TouchableOpacity
              activeOpacity={0.8}
              onPress={onGoBack}
              testID='profileOnGoBackButton'
              accessibilityLabel='profileOnGoBackButton'
            >
              <Icon
                name='LeftArrow'
                height={30}
                width={30}
                fill={theme.CATSKILL_WHITE}
              />
            </TouchableOpacity>
            <View style={styles.rightOptions}>
              <TouchableOpacity
                activeOpacity={0.8}
                style={styles.helpOption}
                onPress={handleHelpModal}
                testID='profileOpenHelpModalButton'
                accessibilityLabel='profileOpenHelpModalButton'
              >
                <Icon
                  name='Faq'
                  height={20}
                  width={20}
                  fill={theme.WHITE_TEXT}
                />
              </TouchableOpacity>
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={handleSetToggle}
                testID='profileChangeThemeButton'
                accessibilityLabel='profileChangeThemeButton'
              >
                <Icon
                  name={isLightTheme ? 'Moon' : 'Sun'}
                  height={20}
                  width={20}
                  fill={theme.WHITE_TEXT}
                />
              </TouchableOpacity>
            </View>
          </View>

          <TouchableOpacity
            style={styles.avatarContainer}
            onPress={handleImagePicker}
            testID='profilePhotoButton'
            accessibilityLabel='profilePhotoButton'
            disabled
          >

            {updateUserPhotoLoading ? <Spinner />
              : (
                <Image
                  name='defaultAvatar'
                  src={user?.avatar ? getAvatarImage(user?.avatar) : null}
                  style={styles.avatar}
                  mode='cover'
                />)}
          </TouchableOpacity>
        </ParticlesBackground>
      </View>
    </View>
  )
}

ProfileTopbar.propTypes = {
  style: ViewPropTypes.style,
  handleHelpModal: PropTypes.func
}

export default ProfileTopbar
